import {
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import {
    ServiceCenterTabs,
} from 'app/enums/domain.enums'
import {
    ServiceCentersTableType,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'
import {
    RegionZeroLevel,
    ServiceCenterStatus,
    ServiceCenterType,
    ServiceProcess,
} from 'app/enums/label.enums'

import serviceCenterRequests from 'app/requests/ServiceCenter/ServiceCenter.requests'
import {
    SkyNetObjectConfigParams,
} from '../SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import ServiceCentersDemoScenarioEditor from './ServiceCentersDemoScenarioEditor'

const columns: SkyNetTableField<keyof ServiceCentersTableType>[] = [
    {
        name: 'serviceCenterNumber',
        labelKey: 'SERVICE_CENTER',
        reduced: true,
    },
    {
        name: 'locationLocationName',
        filterField: 'locationLocationName',
        filterType: FilterType.Array,
        labelKey: 'LOCATION',
        reduced: true,
    },
    {
        name: 'serviceCenterStatus',
        filterField: 'serviceCenterStatus',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: ServiceCenterStatus,
        labelKey: 'STATUS',
    },
    {
        name: 'serviceCenterType',
        filterField: 'serviceCenterType',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: ServiceCenterType,
        labelKey: 'TYPE',
    },
    {
        name: 'orderSelectionDelay',
        labelKey: 'ORDER_SELECTION_DELAY',
    },
    {
        name: 'enabledProcesses',
        componentName: 'EnumList',
        allowedValuesEnum: ServiceProcess,
        labelKey: 'ENABLED_PROCESSES',
    },
    {
        name: 'regionZeroLevel',
        filterField: 'regionZeroLevel',
        filterType: FilterType.Array,
        componentName: 'EnumValue',
        allowedValuesEnum: RegionZeroLevel,
        labelKey: 'REGION_LEVEL_0',
    },
]

const request: RequestConfig = {
    url: 'servicecenter/filter-request/all',
    method: 'POST',
}

export const formViews = [{
    label: 'Scenario Editor',
    url: ServiceCenterTabs.ScenarioEditor,
    Component: ServiceCentersDemoScenarioEditor,
    skyNetQueryLoaderConfig: {
        requestConfigFunction: serviceCenterRequests.get,
        requestKey: RequestKeys.getServiceCenterById,
    },
}]

const ServiceCentersDemoConfig: SkyNetObjectConfigParams<keyof ServiceCentersTableType> = {
    persistentKey: 'demo-serviceCenters-table',
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'All',
        requestKey: RequestKeys.getServiceCenters,
        request,
    }],
}

export default ServiceCentersDemoConfig
